import Box from '@mui/material/Box';
import NoData from '@root/components/common/NoData';
import MuiTable from '@root/components/table/table';
import ContentBox from '@root/components/v2/content/ContentBox';
import { useMemo } from 'react';
import CardTitle from './CardTitle';
import { CARD_BODY_HEIGHT, CARD_TITLE_STYLE } from './cardUtils';

// Card shell for the dashboard's top-5 tables: the shared header, then a compact card table sized by
// the card (no auto height), so MuiTable's loading overlay has a box to fill before rows land.
// Header plus five 40px rows fit the 260px body of a 300px card.
const ROW_HEIGHT = 40;
const HEADER_HEIGHT = '36px';

const TableCard = ({ title, columns, rows, getRowId, isLoading = false, noDataMessage, height = '300px' }) => {
  const tableRows = useMemo(
    () => (Array.isArray(rows) ? rows : []).map((row, index) => ({ ...row, id: getRowId?.(row) ?? index })),
    [rows, getRowId],
  );

  return (
    <ContentBox
      title={<CardTitle title={title} count={isLoading ? undefined : tableRows.length} />}
      titleContainerStyle={CARD_TITLE_STYLE}
      containerClassName={'border-box-no-pad'}
      paddingMode="content"
      height={height}>
      <Box sx={{ height: CARD_BODY_HEIGHT, width: '100%' }}>
        {!isLoading && !tableRows.length ? (
          <NoData message={noDataMessage} imageheight="60px" imageWidth="60px" />
        ) : (
          <MuiTable
            columns={columns}
            rows={tableRows}
            pagination={false}
            hideFooter
            rowHeight={ROW_HEIGHT}
            headerHeight={HEADER_HEIGHT}
            isCardTable
            hoverScrollbar
            LoaderState={isLoading}
            skeletonRowHeight={ROW_HEIGHT}
            noDataMessage={noDataMessage}
          />
        )}
      </Box>
    </ContentBox>
  );
};

export default TableCard;
